import { propsToArray } from 'web/data/core-data'
import { SPELL_ID } from '../ids/spell-id'
import { SpecRole, SpecMap } from 'web/data/models'
import { SPEC_ID } from '../ids/spec-ids'
import { CLASS_ID } from 'web/data/general/id'

export const PALADIN_SPECS: SpecMap = {

    [SPEC_ID.PALADIN.HOLY]: {
        id: SPEC_ID.PALADIN.HOLY,
        name: "Holy",
        shortName: "Holy",
        spellIds: propsToArray(SPELL_ID.PALADIN.HOLY),
        talentIds: [],
        role: SpecRole.Healer,
        classId: CLASS_ID.PALADIN,

        icon_name: "spell_holy_holybolt",
    },

}
